import { Stack, createStyles } from '@mantine/core';
import { Banner, Title } from '@repo/foundations';

import type { AutomationJob } from '../../../api/types/models/automation/automationJob';
import { AutomationHistoryDetailsTable } from '../../Automation/AutomationHistoryDetailTable';
import { AUTOMATION_JOB_STATUS } from '../../Automation/utils';
import { AutomationJobDrawerAiOutputTable } from './AutomationJobDrawerAiOutputTable';

interface AutomationJobDrawerResourceTableProps {
	automationJob: AutomationJob;
	handleCompleteAutomationReview: (automationJobId: string) => void;
}

const useStyles = createStyles(() => ({
	title: {
		flexGrow: 1,
	},
}));

export function AutomationJobDrawerResourceTable({
	automationJob,
	handleCompleteAutomationReview,
}: AutomationJobDrawerResourceTableProps) {
	const { classes, theme } = useStyles();

	const automationStatus = automationJob.status;
	const displayTable =
		automationStatus === AUTOMATION_JOB_STATUS.PENDING ||
		automationStatus === AUTOMATION_JOB_STATUS.COMPLETED;

	return (
		<Stack spacing={theme.spacing.md}>
			<Title size="md" className={classes.title}>
				Resources
			</Title>
			{displayTable && automationStatus === AUTOMATION_JOB_STATUS.PENDING && (
				<Stack spacing={theme.spacing.md}>
					<Banner
						tone="info"
						message="AI-generated updates pending review. Select a resource to review."
						inCard
					/>
					<AutomationJobDrawerAiOutputTable
						automationJob={automationJob}
						handleCompleteAutomationReview={handleCompleteAutomationReview}
					/>
				</Stack>
			)}
			{displayTable && automationStatus === AUTOMATION_JOB_STATUS.COMPLETED && (
				<AutomationHistoryDetailsTable automationJobId={automationJob.id} />
			)}
		</Stack>
	);
}
